export default __webpack_public_path__ + "static/media/systemic-pathology.9dc399f6.svg";